<template>
  <v-footer class="pa-6" color="primary">
    <v-container class="text-center">
      <div
        class="d-flex justify-space-between align-center flex-column flex-md-row"
      >
        <p>
          © 2026 RKay. Crafted with love 🤍
          <!-- · Designed by -->
          <!-- <a class="personal-link" href="">Jose</a> -->
        </p>

        <div>
          <a class="return-policy-link" href="/return-policy"
            >Return & Exchange Policy
          </a>
          <span class="ms-5 me-2">|</span>
          <v-btn
            href="https://www.instagram.com/rkayclothing"
            target="_blank"
            rel="noopener"
            icon
            variant="text"
          >
            <v-icon
              class="return-policy-link"
              icon="mdi-instagram"
              size="small"
              flat
          /></v-btn>
        </div>
      </div>
    </v-container>
  </v-footer>
</template>
<style>
.return-policy-link {
  color: inherit;
  text-decoration: none;
}
.return-policy-link:hover {
  color: #f5f5dc;
  text-decoration: underline;
}
.personal-link {
  color: antiquewhite;
  text-decoration: none;
}
.personal-link:hover {
  color: antiquewhite;
  text-decoration: underline;
}
</style>
